<template>
  <div id="computerinfor">
    <router-view />
  </div>
</template>

<style>
  @import "assets/stylesheets/base.css";
</style>
